export default __webpack_public_path__ + "static/media/success.8f06fb98.gif";